import React from "react";
import {Badge, BadgeProps} from "@mui/joy";
import {screenSizeProvider} from "../../../../stores/ScreenSizeProvider";


interface NotificationBadgeProps extends BadgeProps {
    invisible?: boolean;
}


export const NotificationBadge = (
    {
        anchorOrigin = {
            vertical: 'top',
            horizontal: 'right',
        },
        invisible = false,
        ...props
    }: NotificationBadgeProps) => {
    const isMobile = screenSizeProvider.view !== 'desktop';
    const defaultSx = {
        '& .MuiBadge-badge': {
            backgroundColor: 'var(--lgc-palette-danger-60)',
            top: '6px',
            right: '18px'
        },
        '--Badge-ringSize': '2px',
        '--Badge-paddingX': '0',
        '--Badge-minHeight': '6px',
        '--Badge-ringColor': isMobile
            ? 'var(--lgc-palette-neutral-20)'
            : 'var(--lgc-palette-neutral-100)',
    };

    return (
        <Badge
            anchorOrigin={anchorOrigin}
            sx={defaultSx}
            invisible={invisible}
            {...props}
        />
    );
};
